<template>
  <div class="pa-4 text-center">

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <v-card class="container justify-content-between align-items-center">
        <img src="https://ibliss-icons-dev.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"/>
        <h2 color="primary">{{ $t('login.passChange.label.title') }}</h2>

        <v-container>
          <v-row dense>
            <v-col md="12" sm="6">
              <v-text-field :label="'*'+$t('login.label.passwordChange.title')" :placeholder="$t('login.label.passwordChange.text')" 
                :type="passwordFieldType" required :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" outlined v-model="user.password"
                :rules="passwordRules" color=primary :counter="15" :maxlength="16"
                @click:append="togglePasswordVisibility">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12" sm="6">
              <v-text-field :label="'*'+$t('login.label.confirmPassword.title')" :placeholder="$t('login.label.confirmPassword.text')" 
                :type="confirmationFieldType" required :append-icon="showConfirmation ? 'mdi-eye' : 'mdi-eye-off'" outlined v-model="user.confirmationPassword"
                :rules="confirmPasswordRule" color=primary :counter="15" :maxlength="16"
                @click:append="toggleConfirmationVisibility">
              </v-text-field>
              <span
                v-if="user.password && user.confirmationPassword && validatePasswordRepeat(user.confirmationPassword, user.password) !== null && validatePassword(user.password) === null && validatePassword(user.confirmationPassword) === null"
                class="error-message password-match-rule-error">{{ $t('login.label.passwords.invalid') }}</span>
            </v-col>
            <v-spacer></v-spacer>

            <v-btn large block rounded color="primary" class="mb-4" style="color: white; border-radius: 50px;"
              @click="changePassword">
              {{ $t('button.change') }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  LOGIN_M,
  GET_USER,
  ACTION_UPDATE_PASSWORD
} from "@/views/login/store/types/types.js";
import { mapActions, mapGetters } from 'vuex';
import Swal from "sweetalert2";
import i18n from '@/plugins/i18n';

export default {
  name: "FormPasswordValidation",
  props: {
    forgottenPass: {
      required: true,
      type: Boolean
    },
  },
  data() {
    return {
      dialog: true,
      passwordFieldType: 'password',
      confirmationFieldType: 'password',
      showPassword: false,
      showConfirmation: false,
      passwordsFullyEntered: false,

      user: {
        password: "",
        confirmationPassword: "",
        forgottenPass: this.forgottenPass
      },
    }

  },
  computed: {
    passwordRules() {
      return [
        v => !!v || this.$t('label.password.required'),
        v => v.length >= 8 || this.$t('label.password.minLength'),
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || this.$t('label.password.invalid'),
      ];
    },

    confirmPasswordRule() {
      return [
        v => !!v || this.$t('label.password.required'),
        v => v.length >= 8 || this.$t('label.password.minLength'),
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || this.$t('label.password.invalid'),
      ];
    },

    passwordMatchRule() {
      return [
        v => (!!v && v === this.user.password) || this.$t('login.label.passwords.invalid'),
        v => (!!v && v === this.user.confirmationPassword) || this.$t('login.label.passwords.invalid')
      ];
    }
  },

  methods: {

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.passwordFieldType = this.showPassword ? 'text' : 'password';
    },

    toggleConfirmationVisibility() {
      this.showConfirmation = !this.showConfirmation;
      this.confirmationFieldType = this.showConfirmation ? 'text' : 'password';
    },

    validatePasswordRepeat(passwordRepeat, password) {

      const passwordError = this.validatePassword(password);
      const passwordRepeatError = this.validatePassword(passwordRepeat);

      if (passwordError || passwordRepeatError) {

        return passwordError || passwordRepeatError;
      } else {

        if (passwordRepeat !== password) {
          return this.$t('login.label.passwords.invalid');
        } else {
          return null;
        }
      }
    },
    validatePassword(password) {
      if (!password) return this.$t('label.password.required');
      if (password.length < 8) return this.$t('label.password.minLength');
      if (/(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(password)) return this.$t('label.password.invalid')
            return null;
    },

    ...mapActions({
      putChangePassword: `${LOGIN_M}${ACTION_UPDATE_PASSWORD}`,
    }),

    ...mapGetters({
      obtenerInfoUser: `${LOGIN_M}${GET_USER}`,
    }),


    async changePassword() {
      const errors = this.validateForm();

      if (Object.keys(errors).length > 0) {
        const errorMessages = Object.values(errors).join('<br>');
        return Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.plural.title'),
          html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
          confirmButtonColor: '#6E17A5'
        });
      }
      const updatePassword = await this.putChangePassword(this.user);
      if (!updatePassword) {
        return Swal.fire({
          icon: 'error',
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.invalid.text')
        })
      }

      this.dialog = false;
      window.location.reload();

    },

    validateForm() {
      const PASSWORD_REGEX = /(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&/*(),.?":;{}|<>=+\-^])[A-Za-z\d!@#$%&/*(),.?":;{}|<>=+\-^]{8,}/;

      const errors = {};

      if (!this.user.password || this.user.password.trim().length < 8 || !PASSWORD_REGEX.test(this.user.password)) {
        errors.password = this.$t('login.label.passwordChange.title');
      }

      if (!this.user.confirmationPassword || this.user.confirmationPassword.trim().length < 8 || !PASSWORD_REGEX.test(this.user.confirmationPassword)) {
        errors.confirmationPassword = this.$t('login.label.confirmPassword.title');
      } else if (this.user.confirmationPassword !== this.user.password) {
        errors.confirmationPassword = this.$t('login.label.passwords.invalid');
      }

      return errors;
    },
  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 30vh;
}

.password-match-rule-error {
  color: red;
  font-size: 12px;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;
  }
}
</style>